import { Observer, PartialObserver } from 'rxjs';

export function genCommonObserverObj<T>(observerObj: PartialObserver<T>): Observer<T> {
  return {
    next: (result: T) => {
      if (observerObj.next) {
        observerObj.next(result);
      }
    },
    error: err => {
      if (observerObj.error) {
        observerObj.error(err);
      } else {
        if (!err.isHandle) {
          throw err;
        }
      }
    },
    complete: () => {
      if (observerObj.complete) {
        observerObj.complete();
      }
    }
  };
}

/**
 * reference: https://github.com/angular/angular/blob/e1c2fbd2aff5c4dce29d1153cea4ce117b7d83f5/packages/common/src/i18n/format_number.ts#L24
 *
 * @export
 * @param {string} digitsInfo
 * @returns { {minInt: number, minFraction: number, maxFraction: number} }
 */
export function extractDigitsInfo(digitsInfo: string): { minInt: number, minFraction: number, maxFraction: number } {
  let minInt = 0;
  let minFraction = 0;
  let maxFraction = 0;

  const NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
  const parts = digitsInfo.match(NUMBER_FORMAT_REGEXP);
  if (parts === null) {
    throw new Error(`${digitsInfo} is not a valid digit info`);
  }
  const minIntPart = parts[1];
  const minFractionPart = parts[3];
  const maxFractionPart = parts[5];
  if (minIntPart != null) {
    minInt = parseIntAutoRadix(minIntPart);
  }
  if (minFractionPart != null) {
    minFraction = parseIntAutoRadix(minFractionPart);
  }
  if (maxFractionPart != null) {
    maxFraction = parseIntAutoRadix(maxFractionPart);
  } else if (minFractionPart != null && minFraction > maxFraction) {
    maxFraction = minFraction;
  }

  return { minInt, minFraction, maxFraction };
}

/**
 * reference: https://github.com/angular/angular/blob/e1c2fbd2aff5c4dce29d1153cea4ce117b7d83f5/packages/compiler/src/expression_parser/lexer.ts#L456
 *
 * @export
 * @param {string} text
 * @returns {number}
 */
export function parseIntAutoRadix(text: string): number {
  const result: number = parseInt(text, 10);
  if (isNaN(result)) {
    throw new Error('Invalid integer literal when parsing ' + text);
  }
  return result;
}
